import React from 'react'
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

export default function Auth() {
    const navigate = useNavigate();
    const { doubleSession } = useSelector((state) => state.auth);

    useEffect(() => {
        if (doubleSession) {
            navigate("/ohno", { replace: true });
        }
    }, [doubleSession, navigate]);
    
    return (
        <></>
    )
}